import styles from "./WidgetsListSkeleton..module.scss";

const SKELETON_ROWS = 8;

const rowsArray = Array.from({ length: SKELETON_ROWS });

const WidgetsListSkeleton: React.FC = () => {
  const rowsArray = Array.from({ length: 5 });

  return (
    <div className={styles.wrapper}>
      {rowsArray.map((_, index) => (
        <div key={index} className={styles.item}>
          <div className={styles.left}>
            <div className={`${styles.drag} skeleton`} />
            <div className={`${styles.icon} skeleton`} />
            <div className={`${styles.text} skeleton`} />
          </div>

          <div className={styles.right}>
            <div className={`${styles.btn} skeleton`} />
            <div className={`${styles.badge} skeleton`} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default WidgetsListSkeleton;
